import { useEffect } from 'react';
import { ContentChangeListenerEvent, FocusChangeListenerEvent, TinyMCE } from '../types';

export const useEditorContentChangeEffect = (callback: () => void, editor: TinyMCE | null) => {
  const events = [
    ...Object.values(ContentChangeListenerEvent),
    ...Object.values(FocusChangeListenerEvent),
  ];
  useEffect(() => {
    if (editor) {
      events.forEach((event) => editor.on(event, callback));
      return () => events.forEach((event) => editor.off(event, callback));
    }
  }, [editor, callback]);
};
